// extracted by mini-css-extract-plugin
export default {"fontGotham":"button_fontGotham__0YNa5","button":"button_button__jv0tK","content":"button_content__nfTQ7","icon":"button_icon__T2pyD"};